<div class="gemini-container">
  <!-- =========================================================
       LANDING SCREEN
       ========================================================= -->

  <div *ngIf="!chatMessages.length && !isProcessing" class="landing-screen">
    <div class="landing-content">
      <div class="ai-atomic-logo">
        <div class="orbit ring-one"></div>

        <div class="orbit ring-two"></div>

        <div class="nucleus">✦</div>
      </div>

      <div class="header-text">
        <h1>Interact with Meraki AI</h1>

        <p>Upload a file, enter a prompt, or do both.</p>
      </div>
    </div>
  </div>

  <!-- =========================================================
       CHAT SCREEN
       ========================================================= -->

  <div *ngIf="chatMessages.length || isProcessing" class="chat-screen">
    <!-- =======================================================
         CHAT HEADER
         ======================================================= -->

    <div class="chat-header">
      <div class="chat-header-left">
        <div class="header-ai-icon">
          <div class="ai-atomic-logo small">
            <div class="orbit ring-one"></div>

            <div class="orbit ring-two"></div>

            <div class="nucleus">✦</div>
          </div>
        </div>

        <div>
          <div class="chat-title">Meraki AI</div>

          <div class="chat-subtitle">AI Assistant</div>
        </div>
      </div>

      <button
        type="button"
        class="new-chat-btn"
        (click)="newChat()"
        title="Start a new chat"
      >
        <span class="material-icons"> add </span>

        <span> New chat </span>
      </button>
    </div>

    <!-- =======================================================
         CHAT MESSAGES
         ======================================================= -->

    <div #chatMessagesContainer class="chat-messages">
      <!-- =====================================================
           EXISTING MESSAGES
           ===================================================== -->

      <ng-container
        *ngFor="let message of chatMessages; let messageIndex = index"
      >
        <!-- ===================================================
             USER MESSAGE
             =================================================== -->

        <div
          *ngIf="message.role === 'user'"
          class="chat-message user-message"
          @chatMessageAnimation
        >
          <div class="message-content">
            <div class="message-label">You</div>
            <!-- ATTACHED FILE DISPLAY BADGE -->
            <div class="attached-file-badge" *ngIf="message.file">
              <span class="material-icons file-icon">picture_as_pdf</span>
              <div class="file-info">
                <span class="file-name">{{ message.file.name }}</span>
                <span class="file-type">Uploaded Document</span>
              </div>
            </div>
            <div class="user-bubble">
              {{ message.content }}
            </div>
          </div>
        </div>

        <!-- ===================================================
             AI MESSAGE
             =================================================== -->

        <div
          *ngIf="message.role === 'model'"
          class="chat-message ai-message"
          @chatMessageAnimation
        >
          <div class="ai-avatar">
            <div class="ai-atomic-logo small">
              <div class="orbit ring-one"></div>

              <div class="orbit ring-two"></div>

              <div class="nucleus">✦</div>
            </div>
          </div>

          <div class="message-content">
            <div class="message-label">Meraki AI</div>

            <div class="ai-response">
              <!-- =============================================
                   RESPONSE TIME
                   ============================================= -->

              <div class="response-info" *ngIf="message.responseTimeText">
                ⚡ Generated in
                {{ message.responseTimeText }}
              </div>

              <!-- =============================================
                   NORMAL TEXT RESPONSE
                   ============================================= -->

              <!-- =============================================
     NORMAL TEXT RESPONSE
     ============================================= -->
              <div
                *ngIf="message.displayType !== 'table'"
                class="ai-text-response"
              >
                <markdown
                  [data]="
                    message.displayedContent !== undefined
                      ? message.displayedContent
                      : message.content
                  "
                ></markdown>

                <span *ngIf="message.isTyping" class="typing-cursor"></span>
              </div>

              <!-- =============================================
                   TABLE RESPONSE
                   ============================================= -->

              <div
                *ngIf="message.displayType === 'table'"
                class="table-wrapper"
                [class.fullscreen]="
                  isTableExpanded && messageIndex === chatMessages.length - 1
                "
              >
                <!-- =========================================================
     MODERN CURRENCY CONVERTER CARD
     ========================================================= -->
                <div class="table-currency-converter modern-converter">
                  <div class="currency-converter-header">
                    <div class="header-badge">
                      <span class="material-icons">currency_exchange</span>
                    </div>
                    <div>
                      <span class="currency-title"
                        >Live Currency Converter</span
                      >
                      <span class="currency-subtitle"
                        >Real-time dynamic exchange rates</span
                      >
                    </div>
                  </div>

                  <div class="currency-converter-controls">
                    <div class="input-group">
                      <input
                        type="number"
                        [(ngModel)]="message.currencyAmount"
                        placeholder="Enter amount"
                        min="0"
                        class="converter-input"
                      />
                      <select
                        [(ngModel)]="message.fromCurrency"
                        class="converter-select"
                      >
                        <option value="USD">USD - US Dollar</option>
                        <option value="EUR">EUR - Euro</option>
                        <option value="GBP">GBP - British Pound</option>
                        <option value="INR">INR - Indian Rupee</option>
                        <option value="SGD">SGD - Singapore Dollar</option>
                        <option value="AED">AED - UAE Dirham</option>
                      </select>
                    </div>

                    <div class="swap-icon-wrapper">
                      <span class="material-icons">sync_alt</span>
                    </div>

                    <div class="input-group">
                      <select
                        [(ngModel)]="message.toCurrency"
                        class="converter-select"
                      >
                        <option value="INR">INR - Indian Rupee</option>
                        <option value="USD">USD - US Dollar</option>
                        <option value="EUR">EUR - Euro</option>
                        <option value="GBP">GBP - British Pound</option>
                        <option value="SGD">SGD - Singapore Dollar</option>
                        <option value="AED">AED - UAE Dirham</option>
                      </select>

                      <button
                        type="button"
                        class="convert-currency-btn"
                        (click)="convertCurrency(message)"
                        [disabled]="isFetchingRates"
                      >
                        <span>Convert</span>
                        <span class="material-icons">arrow_forward</span>
                      </button>
                    </div>
                  </div>

                  <div
                    class="currency-result-card"
                    *ngIf="message.currencyResult !== undefined"
                  >
                    <div class="result-breakdown">
                      <span class="source-val"
                        >{{ message.currencyAmount | number: "1.2-2" }}
                        {{ message.fromCurrency }}</span
                      >
                      <span class="equals-sign">=</span>
                      <span class="target-val"
                        >{{ message.currencyResult | number: "1.2-2" }}
                        {{ message.toCurrency }}</span
                      >
                    </div>
                  </div>
                </div>
                <!-- Toolbar -->

                <div class="table-toolbar">
                  <div>
                    Found
                    {{ message.tableData?.length || 0 }}
                    records
                  </div>

                  <button
                    type="button"
                    class="expand-btn"
                    (click)="toggleTable()"
                  >
                    {{
                      isTableExpanded &&
                      messageIndex === chatMessages.length - 1
                        ? "✕ Close"
                        : "⛶ Expand"
                    }}
                  </button>
                </div>

                <!-- =========================================
                     SUMMARY
                     ========================================= -->

                <div class="amount-summary" *ngIf="message.amountSummary">
                  <div class="summary-card">
                    <span class="summary-label"> Min </span>

                    <strong>
                      {{ message.amountSummary.min | number: "1.2-2" }}
                    </strong>
                  </div>

                  <div class="summary-card">
                    <span class="summary-label"> Max </span>

                    <strong>
                      {{ message.amountSummary.max | number: "1.2-2" }}
                    </strong>
                  </div>

                  <div class="summary-card">
                    <span class="summary-label"> Avg </span>

                    <strong>
                      {{ message.amountSummary.average | number: "1.2-2" }}
                    </strong>
                  </div>
                </div>

                <!-- =========================================
                     TABLE
                     ========================================= -->

                <table class="ai-table">
                  <thead>
                    <tr>
                      <th
                        *ngFor="let column of message.displayedColumns"
                        (click)="sortTable(message, column)"
                        class="sortable-header"
                      >
                        <div class="header-content">
                          <span>
                            {{ column.replace("_", " ") | titlecase }}
                          </span>

                          <span class="sort-icon">
                            <span
                              *ngIf="sortColumn !== column"
                              class="material-icons sort-default"
                            >
                              unfold_more
                            </span>

                            <span
                              *ngIf="
                                sortColumn === column && sortDirection === 'asc'
                              "
                              class="material-icons"
                            >
                              arrow_upward
                            </span>

                            <span
                              *ngIf="
                                sortColumn === column &&
                                sortDirection === 'desc'
                              "
                              class="material-icons"
                            >
                              arrow_downward
                            </span>
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let row of message.tableData">
                      <td *ngFor="let column of message.displayedColumns">
                        <ng-container
                          *ngIf="isAmountColumn(column); else normalValue"
                        >
                          {{ formatIndianAmount(row[column]) }}
                        </ng-container>

                        <ng-template #normalValue>
                          {{ row[column] }}
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- =====================================================
           INLINE AI PROCESSING
           ===================================================== -->

      <div
        *ngIf="isProcessing"
        class="chat-message ai-message processing-message-row"
      >
        <div class="ai-avatar">
          <div class="ai-atomic-logo small processing-logo">
            <div class="orbit ring-one"></div>

            <div class="orbit ring-two"></div>

            <div class="nucleus">✦</div>
          </div>
        </div>

        <div class="message-content">
          <div class="message-label">Meraki AI</div>

          <div class="inline-processing">
            <div class="processing-orb">
              <div class="processing-ring ring-one"></div>

              <div class="processing-ring ring-two"></div>

              <div class="processing-core">✦</div>
            </div>

            <div class="processing-content">
              <div class="processing-message-container">
                <p
                  class="processing-message"
                  [@messageAnimation]="messageAnimationKey"
                >
                  {{ currentProcessingMessage }}
                </p>
              </div>

              <div class="processing-progress">
                <span
                  *ngFor="let message of processingMessages; let i = index"
                  class="progress-dot"
                  [class.active]="i === currentMessageIndex"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =========================================================
       FIXED CHAT COMPOSER
       ========================================================= -->

  <div class="chat-composer">
    <form (ngSubmit)="onSubmit()" class="composer-form">
      <!-- =====================================================
           SUGGESTIONS
           ===================================================== -->

      <div
        class="suggestion-area"
        *ngIf="filteredSuggestions.length && !chatMessages.length"
      >
        <div
          *ngFor="let item of filteredSuggestions"
          class="suggestion-chip"
          (click)="addSuggestion(item)"
        >
          {{ item }}
        </div>
      </div>

      <!-- =====================================================
           SELECTED FILE
           ===================================================== -->

      <div class="selected-file" *ngIf="selectedFile">
        <div class="selected-file-info">
          <span class="file-icon material-icons"> picture_as_pdf </span>

          <div class="selected-file-details">
            <span class="selected-file-name">
              {{ selectedFile.name }}
            </span>

            <span class="selected-file-type"> PDF document </span>
          </div>
        </div>

        <button
          type="button"
          class="remove-file-btn"
          (click)="removeSelectedFile($event)"
          title="Remove file"
        >
          <span class="material-icons"> close </span>
        </button>
      </div>

      <!-- =====================================================
           COMPOSER
           ===================================================== -->

      <div
        class="composer-box"
        [class.drag-over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
      >
        <!-- Attach -->

        <button
          type="button"
          class="composer-icon-btn"
          (click)="fileInput.click()"
          title="Attach file"
        >
          <span class="material-icons"> attach_file </span>
        </button>

        <input
          #fileInput
          type="file"
          accept=".pdf,application/pdf"
          (change)="onFileSelected($event)"
          hidden
        />

        <!-- Text -->

        <textarea
          id="prompt"
          [(ngModel)]="promptText"
          name="promptText"
          (input)="onPromptChange()"
          (keydown)="onKeydown($event)"
          placeholder="Message Meraki AI... Drag & drop files or use voice input"
          rows="1"
        ></textarea>

        <!-- Clear -->

        <button
          *ngIf="promptText"
          [matTooltip]="'Clear prompt'"
          type="button"
          class="clear-prompt-btn"
          (click)="clearPrompt()"
        >
          ×
        </button>

        <!-- Voice -->

        <button
          type="button"
          class="mic-btn"
          [class.listening]="isListening"
          (click)="toggleVoiceInput()"
          [title]="isListening ? 'Stop listening' : 'Start voice input'"
        >
          <span class="material-icons">
            {{ isListening ? "mic_off" : "mic" }}
          </span>
        </button>

        <!-- Send -->

        <button
          type="submit"
          class="send-btn"
          [disabled]="!promptText.trim() && !selectedFile"
          title="Send"
        >
          <span class="material-icons"> arrow_upward </span>
        </button>
      </div>

      <!-- =====================================================
           DRAG DROP HINT
           ===================================================== -->

      <div class="drag-drop-hint" *ngIf="isDragOver">
        <span class="material-icons"> upload_file </span>

        Drop your PDF here
      </div>

      <!-- =====================================================
           VOICE STATUS
           ===================================================== -->

      <div class="voice-status" *ngIf="isListening">
        <span class="voice-dot"></span>

        Listening... Speak now
      </div>

      <div class="composer-hint">
        Meraki AI can make mistakes. Verify important information.
      </div>
    </form>
  </div>
</div>
